module.exports = __webpack_public_path__ + "img/paragon-inverse.4e6783a3.svg";